import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { DataPlausibilityState, DataPlausibilityStatus } from "./dataPlausibilityTypes";
import { GridSortModel, GridFilterModel } from "@mui/x-data-grid-premium";
import { MarkedMeasurementLogDto } from "../../app/apislices/markedMeasurementLogApi";
import dayjs from "dayjs";

const initialState: DataPlausibilityState = {
  sortModel: [
    { field: "substation", sort: "asc" },
    { field: "switchgear", sort: "asc" },
    { field: "start", sort: "desc" },
  ],
  filterModel: { items: [] },
  isFilterShowing: true,
  selectedStart: dayjs().add(-1, "week").toISOString(),
  selectedEnd: new Date().toISOString(),
  selectedStatus: [DataPlausibilityStatus.open, DataPlausibilityStatus.used, DataPlausibilityStatus.discarded],
  graphDialogSelection: null,
};

const dataPlausibilitySlice = createSlice({
  name: "dataPlausibilitySlice",
  initialState,
  reducers: {
    setSortModel: (state, action: PayloadAction<GridSortModel>) => {
      state.sortModel = action.payload;
    },
    setFilterModel: (state, action: PayloadAction<GridFilterModel>) => {
      state.filterModel = action.payload;
    },
    toggleFilter: (state) => {
      state.isFilterShowing = !state.isFilterShowing;
    },
    setSelectedStart: (state, action: PayloadAction<Date>) => {
      state.selectedStart = action.payload.toISOString();
    },
    setSelectedEnd: (state, action: PayloadAction<Date>) => {
      state.selectedEnd = action.payload.toISOString();
    },
    setSelectedStatus: (state, action: PayloadAction<DataPlausibilityStatus[]>) => {
      state.selectedStatus = action.payload;
    },
    setGraphDialogSelection: (state, action: PayloadAction<MarkedMeasurementLogDto | null>) => {
      state.graphDialogSelection = action.payload;
    },
  },
});
export const {
  setSortModel,
  setFilterModel,
  toggleFilter,
  setSelectedStart,
  setSelectedEnd,
  setSelectedStatus,
  setGraphDialogSelection,
} = dataPlausibilitySlice.actions;

export default dataPlausibilitySlice.reducer;
